import builder from '../builder';
import SingleNeutralIDCard4 from '../../streamline-icons/light/single-neutral-id-card-4.svg';

export default builder('IconSingleNeutralIDCard4Light', SingleNeutralIDCard4);
